import logoUrl from "../assets/brand/logo.svg";
import logoLightUrl from "../assets/brand/logo-light.svg";

/**
 * The Shelf Garden wordmark logo — a single source of truth so every brand spot (site nav, hero, footer,
 * in-game top bar, auth + boot screens) shows the same custom SVG. Height-driven: pass `height` (px) and the
 * width scales with the wordmark's aspect ratio. `alt` defaults to the product name for accessibility.
 */
export function Logo({ height, className, alt = "Shelf Garden", tone = "dark" }: {
  height: number; className?: string; alt?: string;
  /** "light": the cream wordmark, for a dark ground (the site nav, the home page hero). */
  tone?: "dark" | "light";
}) {
  return (
    <img
      src={tone === "light" ? logoLightUrl : logoUrl}
      alt={alt}
      className={className}
      style={{ height, width: "auto", display: "block" }}
    />
  );
}
